import { all } from "redux-saga/effects";
// import mediaSaga from "./mediaSaga";
import startupSaga from "./startupSaga";
import imageSaga from "./imageSaga";
import mediaSaga from "./mediaSaga";
import libraryCardSaga from "./libraryCardSaga";
import AgentSaga from "./agentSaga";
import n8nWorkflowSaga from "./n8nWorkflowSaga";
import queueServicesSaga from "./queueServicesSaga";
import newsGenerationSaga from "./newsGenerationSaga";
import { auroraSqlSaga } from "./auroraSqlSaga";
import { ragSaga } from "./ragSaga";
import aiAutomationSaga from "./aiAutomationSaga";
import apiKeyRegistrationSaga from "./apiKeyRegistrationSaga";
import workflowDesignSubmissionSaga from "./workflowDesignSubmissionSaga";

export default function* rootSaga() {
  yield all([
    // mediaSaga(), // Add mediaSaga to the root saga
    startupSaga(),
    imageSaga(),
    mediaSaga(),
    libraryCardSaga(),
    AgentSaga(0),
    n8nWorkflowSaga(),
    queueServicesSaga(),
    newsGenerationSaga(),
    auroraSqlSaga(),
    ragSaga(),
    aiAutomationSaga(),
    apiKeyRegistrationSaga(),
    workflowDesignSubmissionSaga(),
  ]);
}
